import Dropdown, {Anchor} from '@jetbrains/ring-ui/components/dropdown/dropdown'
import classNames from 'classnames'
import plur from 'plur'
import * as React from 'react'

import QueuedBuildsPopup from '../../../../../../../containers/QueuedBuildsPopup'
import useFlash from '../../../../../../../hooks/useFlash'
import PendingChangesDropdown from '../../../../../../packages/Changes/ChangesDropdown/PendingChangesDropdown.container'

import type {Props} from './BuildTypeStatus.types'

import styles from './BuildTypeStatus.css'

function BuildTypeStatus({
  loading = false,
  running = 0,
  queued = 0,
  buildTypeId,
  branch,
  className,
  outdated = false,
}: Props) {
  const flash = useFlash([queued])
  const classes = classNames(styles.buildTypeStatus, className)
  const queuedClasses = classNames(styles.queuedAnchor, {
    [styles.flash]: flash,
  })
  return (
    <div className={classes} data-test="buildtype-status" data-queued-count={queued}>
      {loading ? (
        <span className={styles.loading}>{'Loading...'}</span>
      ) : (
        <>
          {running > 0 && <div>{`${running} ${plur('build', running)} running`}</div>}
          {running === 0 && outdated && <div>{'Last build more than 1 month ago'}</div>}
          <div>
            {queued > 0 && (
              <Dropdown
                hoverMode
                className={styles.queued}
                anchor={<Anchor className={queuedClasses}>{`${queued} in queue`}</Anchor>}
              >
                <QueuedBuildsPopup buildTypeId={buildTypeId} className={styles.queuedPopup} />
              </Dropdown>
            )}
            <PendingChangesDropdown
              className={styles.pending}
              linkClassName={styles.pending}
              buildTypeId={buildTypeId}
              branch={branch}
            />
          </div>
        </>
      )}
    </div>
  )
}

export default BuildTypeStatus
